import AddBook from "../components/add/AddBook";

export default function Add() {
  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
          <AddBook />
        </div>
      </div>
    </main>
  );
}
